<template>
 <!-- 使用：
 1、引入组件
 2、语法：
    <analysis>
        内容
    </analysis> 
3.父组件 增加 position:relative;-->
 <div :class="['analysis',className != 'analysis'?className:'']">
   <div :class="['signHome_analysis_btn',className != 'analysis'?className+'_'+'signHome_analysis_btn':'']" :style="{'top':btnTop,'left':btnLeft}">?</div>
   <div class="signHome_analysis_con">
        <div :class="['signHome_analysis_text',className != 'analysis'?className+'_'+'signHome_analysis_text':'']" :style="{'top':textTop,'left':textLeft}">
            <slot></slot>
        </div>
   </div>

 </div>
</template>
<script>
export default {
  props: {
      className:{
        type:String,
        default:'analysis'
      },
      btnTop:{
          type:String,
          default:'29px'
      },
      btnLeft:{
          type:String,
          default:'111px'
      },
      textTop:{
          type:String,
          default:'47px'
      },
      textLeft:{
          type:String,
          default:'108px'
      }
  },
  data() {
    return {};
  },
  mounted() {
    this.showAnalysis();
  },
  methods: {
    showAnalysis(){
      if(this.className != 'analysis'){
        $(`.${this.className}_signHome_analysis_btn`).click(()=>{
            $(`.${this.className}_signHome_analysis_text`).css('display','block')
          })
          $(`.${this.className}_signHome_analysis_text`).hover(function () {
          // 鼠标移入时添加apply-class-hoverr类
              $(this).css('display','block')
            },
            function () {
              // 鼠标移入时移出apply-class-hoverr类
              $(this).css('display','none')
            }
          )
           $(`.${this.className}_signHome_analysis_btn`).hover( ()=> {
          // 鼠标移入时添加apply-class-hoverr类
              // $(`.${this.className}_signHome_analysis_text`).css('display','block')
            },
             ()=> {
              // 鼠标移入时移出apply-class-hoverr类
              $(`.${this.className}_signHome_analysis_text`).css('display','none')
            }
          )
      }else{
         $('.signHome_analysis_btn').click(()=>{
            $('.signHome_analysis_text').css('display','block')
          })
          $('.signHome_analysis_text').hover(function () {
          // 鼠标移入时添加apply-class-hoverr类
              $(this).css('display','block')
            },
            function () {
              // 鼠标移入时移出apply-class-hoverr类
              $(this).css('display','none')
            }
          )
           $(`.signHome_analysis_btn`).hover( ()=> {
          // 鼠标移入时添加apply-class-hoverr类
            },
             ()=> {
              // 鼠标移入时移出apply-class-hoverr类
              $(`.signHome_analysis_text`).css('display','none')
            }
          )
      }
    },
  }
};
</script>
<style lang="scss" scoped>
    .analysis{
        .signHome_analysis_btn{
            width: 18px ;
            height: 18px ;
            border-radius: 50%;
            color: #fff;
            background: #ccc;
            cursor: pointer;
            text-align: center;
            line-height: 19px;
            font-size: 12px;
            position: absolute;
            top: 29px;
            left: 111px;
            z-index: 99;
        }
        .signHome_analysis_text{
            width: 300px;
            height: auto;
            background: #fff;
            border-radius: 3px;
            position: absolute;
            top: 52px;
            left: 108px;
            text-align: left;
            border: 1px solid #c0c0c0;
            font-size: 13px;
            z-index: 99;
            padding: 10px;
            display: none;
            color: #666666;
        }
    }
</style>